import React, { useEffect, useState } from 'react';
import {
    ColumnGap,
    FilterClearButton,
    FilterContainer,
    FlexDirectionWrapper,
    MainContent,
    SubTitle,
    Text,
} from '../../../../../components/StyledComponents';
import { SearchInputAdmin } from '../../../../../components/SearchInputAdmin';
import { formatDateToBR, formatHoursToBRWithoutSeconds } from '../../../../../utils/time';
import FiltersModel from '../../../filters.model';
import { removeEmpty, sortByDirection } from '../../../../../utils/utils';
import { TableAdmin } from '../../../../../components/TableAdmin';
import { handleModalAdmin } from '../../../../../utils/handleModalAdmin';
import { AtendimentoService } from '../../../services/atendimentoService';

import { cnpjMask, cpfMask, formatDefaultValueSelect, numberLocale, } from '../../../../../utils/mask';
import { useApp } from "../../../../../context/app";
import { Accordion, AccordionDetails } from "@material-ui/core";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import { BaSeIcon } from "@base/react";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { FilterSelectAdmin } from "../../../../../components/FilterSelectAdmin";
import Grid from "@material-ui/core/Grid";
import Checkbox from "../../../../../components/Checkbox";

const tableColumns = [
    {
        id: 'dataAtendimento',
        label: 'Data',
        minWidth: 10,
        handleField: formatDateToBR,
    },
    {
        id: 'dataAtendimento',
        label: 'Hora',
        align: 'left',
        minWidth: 10,
        handleField: formatHoursToBRWithoutSeconds,
    },
    {
        id: 'uf',
        returnCompleteRow: true,
        label: 'UF',
        align: 'left',
        minWidth: 10,
        handleField: (data) => {
            return (
                <p>
                    {data?.empreendedor?.dadoComplementar?.siglaEstado ||
                        data?.empreendedor?.uf ||
                        data?.uf?.sigla
                    }
                </p>
            )
        },
    },
    {
        field: 'cidade',
        id: 'cidade',
        label: 'Cidade',
        returnCompleteRow: true,
        align: 'left',
        minWidth: 100,
        handleField: (data) => (
            <p>
                {formatDefaultValueSelect(
                    data?.empreendedor?.dadoComplementar?.cidade ||
                    data?.empreendedor?.cidade?.nome
                )}
            </p>
        ),
    },
    {
        field: 'nomeAtendente',
        id: 'nomeAtendente',
        label: 'Agente',
        align: 'left',
        minWidth: 100,
    },
    {
        id: 'empreendedor',
        field: 'empreendedor',
        returnAsObject: true,
        label: 'CPF',
        align: 'left',
        minWidth: 135,
        handleField: (empreendedor) => {
            return <p>{cpfMask(empreendedor?.respondente?.cpf ?? empreendedor?.cpfPessoaResponsavel)}</p>
        },
    },
    {
        id: 'empreendedor',
        field: 'empreendedor',
        label: 'CNPJ',
        align: 'left',
        minWidth: 135,
        returnAsObject: true,
        handleField: (data) => {
            return <p>{cnpjMask(data?.cnpj)}</p>
        },
    },
    {
        id: 'empreendedor',
        field: 'empreendedor',
        returnAsObject: true,
        label: "Porte",
        orderBy: "empreendedor.dadoComplementar.porte.sigla",
        handleField: (empreendedor) => {
            return (empreendedor?.dadoComplementar?.porte?.sigla ?? empreendedor?.porteApp?.sigla ?? "");
        },
        minWidth: 5,
    },
    {
        field: 'treinamento',
        id: 'treinamento',
        label: 'Testador',
        handleField: (treinamento) => treinamento ? 'Sim' : 'Não',
        align: 'left',
        minWidth: 100,
    },
    {
        field: 'actions',
        id: 'actions',
        label: 'Status',
        minWidth: 100,
        align: 'left',
    },
];

export const Gerenciar = () => {
    const {
        inputSearchValue,
        setInputSearchValue,
        filters,
        setFilters,
        paginationFilters,
        setPaginationFilters,
        handleOrderClick,
        onLinesPerPageChange,
        handlePageChange,
        handleInputPageChange,
        filterOptions,
        setFilterOptions,
        isLoading,
        setIsLoading,
        showModal,
    } = FiltersModel({
        orderBy: 'dataAtendimento',
    });

    const {setRenderIncludeScreen, setManageItem} = useApp();
    const [data, setData] = useState({});

    const getBodyParams = () => {
        return removeEmpty({...filters, oqueVoceProcura: inputSearchValue});
    };

    //
    const getData = async () => {
        try {
            const bodyParams = getBodyParams();
            const response = await AtendimentoService.findAll(
                paginationFilters,
                {...bodyParams}
            );
            setData(response);
            setIsLoading(false);
        } catch (e) {
            setIsLoading(false);
            console.log('erro =>>', e);
        }
    }

    const getOptionsData = async () => {
        const response = await AtendimentoService.getFilterOptions();
        setFilterOptions(response);
    };

    useEffect(() => {
        getData();
        // https://github.com/facebook/create-react-app/issues/6880
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [paginationFilters, filters, inputSearchValue, filterOptions]);

    useEffect(() => {
        setIsLoading(true);
        getOptionsData();
        // https://github.com/facebook/create-react-app/issues/6880
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onClickClearFilters = async () => {
        setIsLoading(true);
        setData({});
        setInputSearchValue(null);
        setFilters({});
        setPaginationFilters({
            page: 0,
            linesPerPage: 10,
            orderBy: 'dataAtendimento',
            direction: 'DESC',
        });
    }

    const handleEditClick = (item) => {
        setManageItem({
            type: 'edit',
            data: item,
        });
        setRenderIncludeScreen(true);
    };

    const handleDeleteClick = (id) => {
        handleModalAdmin({
            title: `Excluir`,
            content: `Você tem certeza que deseja excluir esse registro?`,
            msgOnSuccess: `Registro excluído com sucesso`,
            showAPIErrorIfAvailable: true,
            onFinish: () => {
                setIsLoading(true);
                setData([]);
                getData();
            },
            onConfirmClick: async () => await AtendimentoService.delete(id),
            showModal: showModal,
        });
    };

    const onChangeItemFilter = (event, field, asArray = false) => {
        event.stopPropagation();
        const fieldValue = event.target.value
            ? JSON.parse(event.target.value)
            : event.target.value;
        setFilters({...filters, [field]: !asArray ? fieldValue : [fieldValue]});
    };

    const renderFilters = (color) => {
        return (
            <FilterContainer>
                <Accordion style={{backgroundColor: '#F8F8F8', marginBottom: 20}}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon/>}
                        aria-controls="accordion-filter"
                        id="accordion-filter"
                    >
                        <BaSeIcon
                            name="filter"
                            color={color}
                            size={25}
                            description="Ícone de filtro"
                        />
                        <p style={{color: color, fontWeight: 'bold'}}>Filtrar</p>
                        <FilterClearButton
                            color={color}
                            onClick={(e) => {
                                e.stopPropagation();
                                onClickClearFilters();
                            }}
                        >
                            <BaSeIcon
                                name="close"
                                size={10}
                                color={color}
                                description="Limpar filtros"
                            />
                            <p
                                style={{
                                    fontSize: '12px',
                                    color: color,
                                    borderBottom: `1px solid ${color}`,
                                }}
                            >
                                Limpar filtros
                            </p>
                        </FilterClearButton>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Grid container spacing={2} conlumn={16}>
                            {/* LEFT */}
                            <Grid item container md={8} spacing={2}>
                                <Grid item md={2}>
                                    <FilterSelectAdmin
                                        label="UF"
                                        placeholder={'Selecione'}
                                        options={sortByDirection(filterOptions?.ufs, 'sigla')}
                                        value={filters?.ufs?.[0]}
                                        optionLabel={'sigla'}
                                        onChangeItem={(event) => onChangeItemFilter(event, 'ufs', true)}
                                    />
                                </Grid>

                                <Grid item md={4}>
                                    <FilterSelectAdmin
                                        label="Nome do atendente"
                                        placeholder={'Selecione'}
                                        options={sortByDirection(filterOptions?.atendentes, 'nome')}
                                        value={filters?.atendentes}
                                        optionLabel={'nome'}
                                        onChangeItem={(event) =>
                                            onChangeItemFilter(event, 'atendentes')
                                        }
                                    />
                                </Grid>

                                <Grid item md={4}>
                                    <FilterSelectAdmin
                                        label="Testador"
                                        placeholder={'Selecione'}
                                        options={[true, false]}
                                        formatLabel={(value) => value ? 'Sim' : 'Não'}
                                        value={filters?.treinamento}
                                        optionLabel={'label'}
                                        onChangeItem={(event) =>
                                            onChangeItemFilter(event, 'treinamento')
                                        }
                                    />
                                </Grid>
                            </Grid>

                            <Grid item container md={8} spacing={2}>
                                <Grid item >
                                    <Checkbox
                                        placeholder={"Com inconsistências de cadastro"}
                                        checked={!!filters?.isInconsistente}
                                        value={!filters?.isInconsistente}
                                        onChange={(value) => {
                                            setFilters((f) => ({ ...f, isInconsistente: value }));
                                        }}
                                    />
                                </Grid>
                            </Grid>

                        </Grid>

                    </AccordionDetails>
                </Accordion>
            </FilterContainer>
        );
    };

    return (
        <MainContent>
            <SubTitle>
                <>
                    <h3>Gerenciar</h3>
                    <SearchInputAdmin
                        value={inputSearchValue}
                        onChange={setInputSearchValue}
                    />
                </>
            </SubTitle>

            {renderFilters('#B3B3B3')}

            <FlexDirectionWrapper
                style={{justifyContent: 'space-between', marginTop: '12px'}}
            >
                <ColumnGap gap="4px">
                    <Text color="#0061C6" weight="bold">
                        {numberLocale(data?.totalElements) ?? 0}
                    </Text>
                    <Text color="#B3B3B3">
                        {data?.totalElements === 1 ? 'resultado' : 'resultados'} encontrados
                    </Text>
                </ColumnGap>

            </FlexDirectionWrapper>

            <TableAdmin
                {...{
                    data,
                    paginationFilters,
                    onLinesPerPageChange,
                    handleEditClick,
                    handleDeleteClick,
                    handleOrderClick,
                }}
                isLoading={isLoading}
                sentEntireObjectToEdit
                sentEntireObjectToCopy
                columnAction={'actions'}
                linesPerPageFilters={paginationFilters?.linesPerPage}
                pagination={true}
                totalPages={data?.totalPages}
                columns={tableColumns}
                tableColor={'#0061C6'}
                lineColor={'rgba(0, 97, 198, 0.1)'}
                onPagePreviousChange={handlePageChange}
                onPageNextChange={handlePageChange}
                onInputPageChange={handleInputPageChange}
            />
        </MainContent>
    );
};
